import Vue from 'vue'
// import * as echarts from 'echarts'
import router from './router'
import App from './App.vue'
import ElementUI from "element-ui";
import axios from "./http.js";
import "element-ui/lib/theme-chalk/index.css";

Vue.prototype.$axios = axios;
// Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
